// 特殊的同步调用api
import env from '../util/env';
import url from '../util/url';

const androidResolveMap = {
    default: res => JSON.parse(res),
};
const iosResolveMap = {
    ...androidResolveMap,
};

/**
 * 安卓端直接调用注入的对象函数
 * @param {string} apiName
 * @param  {*} options
 */
function syncCallAndroid(apiName, options) {
    const resolveHandler = androidResolveMap[apiName] || androidResolveMap.default;
    const res = typeof options === 'undefined' ? window.blackUnique[apiName]() : window.blackUnique[apiName](options);
    return resolveHandler(res);
}

/**
 * ios端通过调用window.prompt调用
 * @param {*} apiName
 * @param  {*} options
 */
function syncCallIos(apiName, options) {
    const resolveHandler = iosResolveMap[apiName] || iosResolveMap.default;
    const query = url.queryToString({ ...options, api: apiName });
    // eslint-disable-next-line no-alert
    const res = window.prompt(`_black_unique_bridge_?${query}`);
    return resolveHandler(res);
}

/**
 * 同步调用原生插件，只支持某些特定插件
 * 每新增一个插件请在shop/src/common/nativeApi/syncApi.d.ts内
 * ApiOptResMap类型中增加入参出参配置，这样会有代码提示
 */
export default function syncCall(apiName, options) {
    if (!env.isApp) throw new Error('非app不能调用syncCall');
    if (env.isAndroid) return syncCallAndroid(apiName, options);
    if (env.isIos) return syncCallIos(apiName, options);
    throw new Error('非支持的用户端');
}
